import { ReactElement } from 'react'

import { useTranslation } from 'react-i18next'
import { Link, useLocation } from 'react-router-dom'

import { Flex, Icon } from 'components/core'
import { ToolTip } from 'components/ToolTip'
import { useAnalytics } from 'features/Monitoring/Segment/useAnalytics'
import { userHasSovReadPermissions } from 'helpers/featurePermissions'
import { useUserHasPermissions } from 'hooks'
import { sovAsinReverseResearchUrl, sovKeywordResearchUrl } from 'routing/urls'
import { CountryCode } from 'types'

import * as styles from './styles.scss'

interface ResearchKeywordLinkProps {
    countryCode: CountryCode
    keyword?: string
    asin?: string
}

export function ResearchKeywordLink({
    countryCode,
    keyword,
    asin,
}: ResearchKeywordLinkProps): ReactElement | null {
    const { t } = useTranslation('sov')
    const { trackCtaClick } = useAnalytics()

    const hasShelfIntelligenceModule = useUserHasPermissions(
        userHasSovReadPermissions
    )

    const location = useLocation()

    if (!hasShelfIntelligenceModule || (!keyword && !asin)) {
        return null
    }

    const title = keyword
        ? t(
              'sov:keywordResearch.searchThisKeyword.tooltip',
              'Research this keyword'
          )
        : t(
              'sov:keywordResearch.searchThisAsin.tooltip',
              'Research this product'
          )

    const url = keyword
        ? sovKeywordResearchUrl(countryCode, keyword)
        : sovAsinReverseResearchUrl(countryCode, asin ?? '')

    return (
        <Flex margin="0 2px" className={styles.actions}>
            <ToolTip title={title} className={styles['research-link']}>
                <Link
                    to={url}
                    onClick={() =>
                        trackCtaClick({
                            destination: url,
                            text: 'Keyword Research - Search Icon Clicked',
                            type: 'icon',
                            location: location.pathname,
                        })
                    }
                    style={{ height: 14 }}
                >
                    <Icon name="SEARCH" />
                </Link>
            </ToolTip>
        </Flex>
    )
}
